import React from 'react';
import AnimatedSection from '../../components/AnimatedSection';

const AboutPage = () => {
  const historyData = [
    { year: "2001", event: "[2001.03] 진양채양공사 설립" },
    { year: "2002", event: "[2002.11] 진양채양공사\n진양판넬, 진양컨테이너 개소" },
    { year: "2011", event: "[2011.04] 178호 뉴스 매거진 게재\n[2011.05] 스포츠서울 기업브랜드 대상" },
    { year: "2012", event: "[2012.02] 연합뉴스 탑브랜드 대상\n[2012.12] 연합뉴스 고객감동 브랜드 대상" },
    { year: "2015", event: "[2015.11] '진양채양공사'를 '진양건설'로 상호 변경\n사무실 신축 이전 및 소재지 변경" }
  ];

  return (
    <>
      <title>회사소개 - 진양건설</title>
      <div className="container mx-auto px-6 py-16 md:py-24 space-y-16">
        <AnimatedSection animationType="fade-in">
          <header className="text-center pt-8 pb-12 rounded-lg">
            <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 dark:text-white tracking-tight">회사 소개</h1>
            <p className="text-xl text-gray-600 dark:text-gray-300 mt-4 max-w-2xl mx-auto">
              20년 이상의 경험과 노하우, 진양건설은 고객님의 소중한 공간을 위한 최고의 지붕 솔루션을 제공합니다.
            </p>
          </header>
        </AnimatedSection>

        <AnimatedSection className="bg-slate-50 dark:bg-slate-800 p-8 md:p-12 rounded-xl shadow-lg">
          <div className='text-left rounded-lg'>
            <h2 className="text-3xl font-bold mb-8 text-center text-gray-800 dark:text-white">인사말</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              안녕하세요. 저희 진양건설 홈페이지를 방문해주신 고객 여러분 이렇게 인사드리게 되어 반갑습니다. <br/><br/>
              당사는 다년간의 노하우와 기술을 바탕으로 최고의 인재와 축적된 기술로서 지붕 공사 업체를 대표로 하고 있습니다. 저희 진양건설은 지붕공사, 지붕 방수, 지붕리모델링을 전문으로 고객님께서 만족하실 수 있는 책임시공을 하고 있습니다.<br/><br/>
              확실한 시공 및 철저한 A/S로 고객님께서 안심하고 맡기실 수 있도록 노력하며, 친절한 서비스로 고객 여러분께서 믿고 찾을 수 있는 진양건설이 될 것을 약속드립니다. 성실 시공으로 고객님의 사랑과 신뢰를 받을 수 있는 기업이 되도록 노력하겠습니다. 작은 일이라도 저희 회사의 명예와 자존심을 걸고 축적된 기술을 바탕으로 완벽하고 창의적인 시공을 해드릴 것을 약속드립니다. 무료로 상담 및 견적서를 작성해드리니 언제든지 전화주시면 친절히 상담해드리겠습니다.<br/><br/>
              새로운 변화가 요구되는 시대. 고객님께서 항상 찾을 수 있는 진양건설로 거듭나는 모습을 지켜봐 주시길 바랍니다.<br/><br/>
              감사합니다.
            </p>
          </div>
        </AnimatedSection>
        
        <AnimatedSection className="grid md:grid-cols-2 gap-12 items-center">
          <div className="order-2 md:order-1">
            <h2 className="text-3xl font-bold mb-6 text-sky-700 dark:text-sky-400">우리의 비전과 미션</h2>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-4">
              <strong>비전:</strong> 저희의 비전은 모든 건물에 가장 안전하고 견고한 지붕을 제공하여, 기후 변화와 외부 환경으로부터 고객의 자산을 완벽하게 보호하는 지붕 기술의 선두주자가 되는 것입니다.
            </p>
            <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
              <strong>미션:</strong> 저희의 미션은 최고의 자재, 숙련된 기술, 그리고 정직한 시공을 통해 모든 고객에게 100% 만족을 드리는 것입니다. 단순한 시공을 넘어, 오랜 시간이 지나도 변치 않는 가치를 만들어갑니다.
            </p>
          </div>
          <div className="order-1 md:order-2 rounded-xl overflow-hidden shadow-2xl">
            <img src="https://placehold.co/800x600/1e3a8a/93c5fd?text=Reliable+Roofing" alt="견고한 지붕 이미지" className="w-full h-auto object-cover" onError={(e) => e.target.src = 'https://placehold.co/800x600/1e3a8a/93c5fd?text=Image+Error'}/>
          </div>
        </AnimatedSection>

        <AnimatedSection className="bg-slate-50 dark:bg-slate-800 p-8 md:p-12 rounded-xl shadow-lg">
          <h2 className="text-3xl font-bold mb-12 text-center text-gray-800 dark:text-white">회사 연혁</h2>
          <div className="relative">
            <div className="hidden md:block absolute top-0 bottom-0 left-1/2 w-0.5 bg-sky-300 dark:bg-sky-700 transform -translate-x-1/2"></div>
            {historyData.map((item, index) => (
              <div key={index} className="relative mb-10 md:mb-16">
                <div className="hidden md:block absolute left-1/2 top-2 transform -translate-x-1/2 z-10">
                  <div className="w-5 h-5 bg-sky-500 dark:bg-sky-400 rounded-full border-2 border-white dark:border-slate-800 shadow-md"></div>
                </div>
                <div className={`md:flex ${index % 2 === 0 ? 'md:flex-row-reverse' : ''} md:items-start`}>
                  <div className={`md:w-1/2 ${index % 2 !== 0 ? 'md:text-right md:pr-10 lg:pr-12' : 'md:text-left md:pl-10 lg:pl-12'} hidden md:block`}>
                    <h3 className="text-2xl font-bold text-sky-600 dark:text-sky-400 pt-1 leading-tight">{item.year}</h3>
                  </div>
                  <div className={`w-full md:w-1/2 ${index % 2 !== 0 ? 'md:pl-10 lg:pl-12' : 'md:pr-10 lg:pr-12'} mt-4 md:mt-0`}>
                    <div className="bg-white dark:bg-slate-700 p-6 rounded-xl shadow-xl border border-gray-200 dark:border-slate-600 hover:shadow-sky-200/50 dark:hover:shadow-sky-700/30 transition-shadow duration-300">
                      <h3 className="block md:hidden text-xl font-bold text-sky-600 dark:text-sky-400 mb-3">{item.year}</h3>
                      {item.event.split('\n').map((eventLine, lineIndex) => (
                        <div key={lineIndex} className="text-gray-700 dark:text-gray-300 leading-relaxed">
                          {eventLine}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </AnimatedSection>
        
        <AnimatedSection>
          <h2 className="text-3xl font-bold mb-8 text-center text-gray-800 dark:text-white">핵심 가치</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[{title: "책임 시공", desc: "기초부터 마감까지, 내 집을 짓는 마음으로 모든 과정을 책임지고 완벽하게 시공합니다."}, 
             {title: "최고의 기술력", desc: "끊임없는 연구와 최신 기술 도입으로 어떤 현장이든 최상의 지붕 솔루션을 제공합니다."}, 
             {title: "고객 만족", desc: "무료 방문 견적부터 투명한 소통, 그리고 철저한 사후 관리(A/S)까지 고객의 만족을 최우선으로 합니다."}
            ].map(value => (
              <div key={value.title} className="bg-gradient-to-br from-sky-50 to-indigo-50 dark:from-sky-900/30 dark:to-indigo-900/30 p-8 rounded-xl shadow-lg text-center transform hover:scale-105 transition-transform duration-300">
                <div className="text-3xl font-extrabold text-sky-600 dark:text-sky-400 mb-3">{value.title}</div>
                <p className="text-gray-600 dark:text-gray-300">{value.desc}</p>
              </div>
            ))}
          </div>
        </AnimatedSection>
      </div>
    </>
  );
}
export default AboutPage;
